
<template>
  <div>
    <el-dialog title="关联设备" :visible.sync="showEqment" :before-close="handleClose"
      :close-on-click-modal="false" :append-to-body="true" lock-scroll
      :close-on-press-escape="false" class="QMS-dialog QMS-dialog_center" width="600px" center>
      <div class="QMS-common-layout-main">
        <el-table ref="multipleTable" :append-to-body="true" :data="tableData" style="width: 100%">
          <el-table-column type="index" width="55" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="equipmentNumber" label="设备编号" align="center">
          </el-table-column>
          <el-table-column prop="equipmentName" label="设备名称" align="center">
          </el-table-column>
          <el-table-column prop="equipmentModel" label="规格型号" align="center">
          </el-table-column>
          <el-table-column prop="equipmentAreaName" label="所在区域" align="center">
          </el-table-column>
          <el-table-column prop="status" label="设备状态" align="center">
            <template slot-scope="scope">
              <span>{{statusList[Number(scope.row.status)-1]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button plain size="mini" @click="handleClose">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    appraisalTestPaperId: {
      default: false
    },
    showEqment: {
      default: false
    },

  },
  data() {
    return {
      tableData: [],
      statusList: ['正常', '停用', '维修中', '维护保养中', '报废']
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    init() {
      this.$net(`/sdau/userClient/appraisalResult/equipmentListByPaperId/${this.appraisalTestPaperId}`, 'get').then(res => {
        this.tableData = res.data
      })
    },
  },
  created() {
    this.init()
  }
}
</script>
